<template>
  <div id="app">
     <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
#app {
  box-sizing: border-box;
  padding: 0px;
  // height: calc(100% - 40px);
  height: 100%;
}
</style>
